<footer>
  <mat-card
    class="mat-card mat-bg-primary text-center"
    style="box-shadow: none !important"
  >
    <p>
      TS-Atende v.<i>{{ version }}</i>
    </p>
    <p>
      <img
        src="assets/images/rodape-tscobra.png"
        width="50"
        style="margin-right: 1em; margin-left: -1em"
      />
      TS-Cobra © 2025
    </p>
  </mat-card>
</footer>
